import { SITE } from "./data";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-ink border-t border-line pt-20 pb-10">
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16">
          <div className="md:col-span-6">
            <img
              src="/media/mg-logo.png"
              alt="MG Tiling Pro — Precision, Quality, Finish"
              className="w-64 md:w-80 lg:w-96 h-auto"
            />
            <p className="font-body font-light text-stone mt-8 max-w-sm">{SITE.tagline}</p>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-xs uppercase tracking-[0.2em] font-bold text-stone mb-6">Areas Served</h3>
            <ul className="space-y-2">
              {SITE.areas.map((a) => (
                <li key={a} className="font-body text-bone">{a}</li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-xs uppercase tracking-[0.2em] font-bold text-stone mb-6">Get in touch</h3>
            <ul className="space-y-3">
              <li>
                <a href={`tel:${SITE.phoneRaw}`} className="font-body text-bone hover:text-terracotta transition-colors">{SITE.phone}</a>
              </li>
              <li>
                <a href={`mailto:${SITE.email}`} className="font-body text-bone hover:text-terracotta transition-colors">{SITE.email}</a>
              </li>
              <li className="font-body text-stone">{SITE.location}</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-line pt-8 flex flex-col md:flex-row justify-between gap-4">
          <p className="font-heading text-xs uppercase tracking-[0.15em] text-stone">
            © {new Date().getFullYear()} {SITE.name} — Master Tilers, Ireland
          </p>
          <p className="font-heading text-xs uppercase tracking-[0.15em] text-stone">
            Fully insured · Time-served · Guaranteed
          </p>
        </div>
      </div>
    </footer>
  );
};
